import CompaniesTemplate from '@/features/agent/companies/templates/CompaniesTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/companies/')({
  component: CompaniesPage,
  staticData: { title: '企業管理' },
});

function CompaniesPage() {
  return <CompaniesTemplate />;
}
